import React from 'react';
import { PreviousManualsType } from '../../util/types';
import Manual from '../Manual/Manual';
import { product as productLabels } from '../../mockdata';
import IndexWrapper from '../IndexWrapper/IndexWrapper';

interface PreviousPageProps extends PreviousManualsType {
  locale: string;
  labels: typeof productLabels;
  backLink?: { href: string; children: string };
  localeCountry?: string;
}

export default function PreviousPage({
  locale,
  name,
  manuals,
  labels,
  backLink,
  localeCountry,
}: PreviousPageProps) {
  return (
    <IndexWrapper
      labels={labels}
      backLink={backLink}
      name={name}
      locale={locale}
      localeCountry={localeCountry}
    >
      <Manual manuals={manuals} title={productLabels.previous_manuals} />
    </IndexWrapper>
  );
}
